import React from 'react'
import moment from 'moment'
import { Divider, Row, Form, Button, Input, Switch, notification, Col, DatePicker, Select } from 'antd'
import API from '../../services/API'
import Segment from '../../components/Segment'
import Search from '../../components/Search'
import { Link } from 'react-router-dom'

const CashdrawalReasonCreate = ({ user }) => {
    const [reason, setReason] = React.useState('')
    const [loading, setloading] = React.useState(false)
    const disabled = reason.length <= 3

    const handleSubmit = e => {
        e.preventDefault()
        setloading(true)
        const newData = {
            name: reason,
        }
        API.post('/api/cash-withdrawal-reasons', newData)
            .then(() => {
                setReason('')
                setloading(false)
                notification.success({
                    message: 'Se ha guardado exitosamente',
                })
            })
            .catch(error => {
                setloading(false)
                console.error('Error al guardar motivo', error)
                if (error.response && error.response.data && error.response.data.message) {
                    notification.error({
                        message: error.response.data.message[0],
                    })
                }
            })
    }

    return (
        <Segment loading={loading}>
            <Divider>Crear motivo de retiro de efectivo</Divider>
            <Form style={{ maxWidth: '800px', margin: 'auto' }}>
                <Form.Item label="Motivo" className="required" hasFeedback>
                    <Input
                        placeholder="Motivo"
                        value={reason}
                        required
                        onChange={e => {
                            setReason(e.target.value)
                        }}
                    />
                </Form.Item>

                <Row type="flex" justify="space-between" style={{ marginTop: '50px' }}>
                    <Form.Item>
                        <Link to="/report/cash-withdrawal">
                            <Button icon="arrow-left">Regresar</Button>
                        </Link>
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" icon="save" disabled={disabled} onClick={handleSubmit}>
                            Guardar
                        </Button>
                    </Form.Item>
                </Row>
            </Form>
        </Segment>
    )
}

export default CashdrawalReasonCreate
